// Utility to check if Strapi API is available
import logger from './logger';

let strapiStatus: boolean | null = null;
let lastCheck: number = 0;
const CHECK_INTERVAL = 30000; // Check every 30 seconds

export const checkStrapiHealth = async (): Promise<boolean> => {
  const now = Date.now();
  
  // Return cached result if checked recently
  if (strapiStatus !== null && (now - lastCheck) < CHECK_INTERVAL) {
    return strapiStatus;
  }

  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

    const response = await fetch(`${process.env.REACT_APP_API_URL || '/api'}/wfc-players`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      signal: controller.signal,
    });

    clearTimeout(timeoutId);
    
    strapiStatus = response.ok;
    lastCheck = now;
    return strapiStatus;
  } catch (error) {
    logger.error('Strapi health check failed:', error);
    strapiStatus = false;
    lastCheck = now;
    return false;
  }
};

export const resetStrapiStatus = () => {
  strapiStatus = null;
  lastCheck = 0;
};
